module.exports = __webpack_public_path__ + "img/kalamaio-logo-full-light-72.d751c37f.png";